import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('CURRENT_USER_ALBUMS').plugin(axiosPlugin, {template: "array"});

let fetchCurrentUserAlbumsAction = redux.fetchActionGet();

export const fetchCurrentUserAlbums = (userId, query = {}) => fetchCurrentUserAlbumsAction(`/users/me/albums?${queryString.stringify(query)}`);
export const resetCurrentUserAlbums = () => redux.actions.reset();

export const currentUserAlbums = redux.reducer();